export class loginModel {
  
    constructor(
      public mail: string,
      public passw: string,
    ) {  }
  
  }
  


// WEBPACK FOOTER //
// ./src/app/create-workspace/http-post-request-object-classes/loginModel.ts